import { FieldSelectorAlertError } from "slot-definitions"
import { FieldErrorsMessage } from "../../fields-errors-message"
import { FIELD_ERROR_NO_UNIQUE, FIELD_ERROR_NO_UNIQUE_TAG } from "../unique-field-error/unique-field-error.runtime"
import { joinList } from "lib/join-list"

FieldSelectorAlertError.plug(<UniqueFieldsError prioriry={300} />)
FieldSelectorAlertError.plug(<UniqueTagError prioriry={300} />)

function UniqueFieldsError() {
    return (
        <FieldErrorsMessage
            errorType={FIELD_ERROR_NO_UNIQUE}
            message={(fields) => {
                const pluralCount = fields.length > 1 ? 1 : 2
                return `${joinList(fields)} ${"require".pluralize(
                    pluralCount
                )} a unique column and none were found - please update your data accordingly and reupload.`
            }}
        />
    )
}

function UniqueTagError() {
    return (
        <FieldErrorsMessage
            errorType={FIELD_ERROR_NO_UNIQUE_TAG}
            message={() =>
                `Asset Tag requires a unique column and none were found.
                You can update and re-upload your data, or tick the option below
                to let Mobiliser create unique values for you.`
            }
        />
    )
}
